import React from "react";
import "../spinner/spinner.scss";
import { CircularProgress } from "@mui/material";

function SpinnerLoading() {
  return (
    <div className="parent">
       <CircularProgress />
    </div>
  );
}

export default SpinnerLoading;
